export * from './auth';
interface ApiResponse<T> {
    code: number;
    message: string;
    data: T | null;
}

export class ResponseEntity<T>{
    code!: number;
    message!: string;
    data!: T | null;

    success(data: T, code?: number, message?: string): ApiResponse<T> {
        this.code = code ?? 200;
        this.message = message ?? '';
        this.data = data;
        return this.getResponse()
    }

    error(code: number, message: string, data?: T | null): ApiResponse<T> {
        this.code = code;
        this.message = message;
        this.data = data ?? null;
        return this.getResponse()
    }

    getResponse(): ApiResponse<T> {
        return {
            code: this.code,
            message: this.message,
            data: this.data as T,
        }
    }
}

type PermissionType = {
    id: number
    menu_id: number
    name: string
    slug: string
    is_selected: number
}


export type MenuType = {
    menu_order?: number
    id: number
    name: string
    slug: string
    url: string
    icon: string
    parent_id?: number
    order_value?: number
    is_active?: boolean
    is_navigable?: boolean
    permissions: Array<PermissionType>
    sub_menus: Array<MenuType>
    role_name?: string
}